module.exports = __webpack_public_path__ + "static/media/205-Pflegemassnahmen_ID_31m.d64f4ca5.mp3";